import React from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from 'primereact/button'

type Props = {
  title: string
  details: string
  value: any
  clearFilter: () => void
}

export const EmptyMessage: React.FC<Props> = ({
  title,
  details,
  value,
  clearFilter,
}) => {
  const { t } = useTranslation()

  return value?.length ? (
    // Too many filters are active
    <div className="text-center">
      <p className="font-bold text-base">
        {t('common.table.emptyMessage.title')}
      </p>
      <p className="text-sm max-w-20rem mx-auto mb-4">
        {t('common.table.emptyMessage.body')}
      </p>
      {clearFilter && (
        <Button
          label={t('common.table.emptyMessage.button')}
          onClick={clearFilter}
        />
      )}
    </div>
  ) : (
    // No data was loaded
    <div className="text-center">
      <p className="font-bold text-base">{title}</p>
      <p className="text-sm">{details}</p>
    </div>
  )
}
